var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const Svg24PxCartSimple1 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4128_9922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.16665 26.8333C9.45531 26.8333 10.5 25.7886 10.5 24.5C10.5 23.2113 9.45531 22.1666 8.16665 22.1666C6.87798 22.1666 5.83331 23.2113 5.83331 24.5C5.83331 25.7886 6.87798 26.8333 8.16665 26.8333Z",
    stroke: "#F68D1F",
    strokeWidth: 2.1,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1666 26.8333C23.4553 26.8333 24.5 25.7886 24.5 24.5C24.5 23.2113 23.4553 22.1666 22.1666 22.1666C20.878 22.1666 19.8333 23.2113 19.8333 24.5C19.8333 25.7886 20.878 26.8333 22.1666 26.8333Z",
    stroke: "#F68D1F",
    strokeWidth: 2.1,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.44482 6.99996H25.6667L23.3333 18.6666H6.99999L4.66666 1.16663H1.16666",
    stroke: "#F68D1F",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4128_9922"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(Svg24PxCartSimple1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/24px_cart-simple1.da51bdad81835eb5d2d6df6aafe4d475.svg";